import { render, staticRenderFns } from "./IconSvgMEMAMHome.vue?vue&type=template&id=a144b6b8&scoped=true&"
import script from "./IconSvgMEMAMHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgMEMAMHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144b6b8",
  null
  
)

export default component.exports